import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import RecipesRecipe from './Recipe';

const MacrosPerPersonFor4Portion = ApplicationRecord.extend({
  attrs: {
    recipe: belongsTo({ type: RecipesRecipe, persist: false }),
    recipe_id: attr({ type: Number }),
    fat: attr({ persist: false }),
    carbohydrates: attr({ persist: false }),
    protein: attr({ persist: false }),
    calories: attr({ persist: false }),
    kilojoules: attr({ persist: false }),
    sugars: attr({ persist: false }),
    salt: attr({ persist: false }),
    fibre: attr({ persist: false }),
    saturated_fat: attr({ persist: false }),
  },
  static: {
    jsonapiType: 'recipes-macros_per_person_for_4_portions',
  },
});

export default MacrosPerPersonFor4Portion;
